<script setup lang="ts">
import NeutralIcon from '@/assets/icons/neutral.svg';
import InProgressIcon from '@/assets/icons/inProgress.svg';
import CompletedIcon from '@/assets/icons/completed.svg';
import type { LumarActivityWeekDto } from '@/plugins/appApi';

defineProps<{ activity: LumarActivityWeekDto }>();
</script>

<template>
  <div
    class="min-[1300px]:hidden min-w-[303px] flex flex-wrap justify-between px-2 py-4 bg-lumar-gray-10 rounded-lg"
  >
    <div class="flex flex-col gap-2">
      <span class="text-xs text-lumar-dark-gray">{{
        activity.week + '. ' + $t('task.week') + ' ' + activity.year
      }}</span>
      <span class="text-lumar-gray font-semibold"> {{ activity.type }} </span>
      <span class="text-xs text-lumar-dark-gray">{{ activity.contractor }}</span>
    </div>
    <div v-if="activity.status === 'Confirmed'">
      <span :title="$t('activity.confirmed')">
        <NeutralIcon />
      </span>
    </div>
    <div v-else-if="activity.status === 'Planned'">
      <span :title="$t('activity.planned')">
        <NeutralIcon />
      </span>
    </div>
    <div v-else-if="activity.status === 'InProgress'">
      <span :title="$t('activity.inProgress')">
        <InProgressIcon />
      </span>
    </div>
    <div v-else-if="activity.status === 'Completed'">
      <span :title="$t('activity.completed')">
        <CompletedIcon />
      </span>
    </div>
  </div>
  <div
    class="hidden min-[1300px]:flex min-w-[303px] h-[204px] p-8 justify-between bg-lumar-gray-10 rounded-lg"
  >
    <div class="flex flex-col justify-between">
      <div class="flex flex-col gap-4">
        <span class="text-[20px] text-lumar-dark-gray">{{
          activity.week + '. ' + $t('task.week') + ' ' + activity.year
        }}</span>
        <span class="text-[24px] text-lumar-gray font-semibold">
          {{ activity.type }}
        </span>
      </div>
      <div>
        <span class="text-[20px] text-lumar-dark-gray">{{ activity.contractor }}</span>
      </div>
    </div>
    <div v-if="activity.status === 'Confirmed'">
      <span :title="$t('activity.confirmed')">
        <NeutralIcon />
      </span>
    </div>
    <div v-else-if="activity.status === 'Planned'">
      <span :title="$t('activity.planned')">
        <NeutralIcon />
      </span>
    </div>
    <div v-else-if="activity.status === 'InProgress'">
      <span :title="$t('activity.inProgress')">
        <InProgressIcon />
      </span>
    </div>
    <div v-else-if="activity.status === 'Completed'">
      <span :title="$t('activity.completed')">
        <CompletedIcon />
      </span>
    </div>
  </div>
</template>
